import { SVGProps } from 'react'

export const NeCloudFileSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g fill='none' fillRule='evenodd'>
      <g>
        <path
          d='m14.438 1.5 6 6v12.75a2.25 2.25 0 0 1-2.25 2.25H5.813a2.25 2.25 0 0 1-2.25-2.25V3.75a2.25 2.25 0 0 1 2.25-2.25h8.625Zm-2.389 8.625c-1.715 0-2.756 1.1-3.162 2.34-.906.23-1.575 1.03-1.575 1.984 0 1.133.946 2.051 2.113 2.051h5.244c1.166 0 2.112-.918 2.112-2.051 0-.951-.667-1.751-1.57-1.983-.407-1.24-1.447-2.341-3.162-2.341Z'
          fill='#4E86E6'
        />
        <path
          d='M14.438 1.5V6a1.5 1.5 0 0 0 1.5 1.5h4.5l-6-6Z'
          fill='#A9C6F3'
        />
      </g>
    </g>
  </svg>
)
